import { render, staticRenderFns } from "./SubscriptionMenu.vue?vue&type=template&id=2718b632&scoped=true&"
import script from "./SubscriptionMenu.vue?vue&type=script&lang=js&"
export * from "./SubscriptionMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionMenu.vue?vue&type=style&index=0&id=2718b632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718b632",
  null
  
)

component.options.__file = "SubscriptionMenu.vue"
export default component.exports